import { render, staticRenderFns } from "./OptionPrice.vue?vue&type=template&id=037c3940&scoped=true&"
import script from "./OptionPrice.vue?vue&type=script&lang=ts&"
export * from "./OptionPrice.vue?vue&type=script&lang=ts&"
import style0 from "./OptionPrice.vue?vue&type=style&index=0&id=037c3940&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037c3940",
  null
  
)

export default component.exports